import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ReplayIcon from "@mui/icons-material/Replay";
import { useNavigate } from "react-router-dom";
import { isDebug } from "../../utils";


export const SearchForm = ({ onChangeText, onSearch }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [keyword, setKeyword] = useState("");

  const searchByKeyword = (e) => {
    e.preventDefault();
    onSearch(keyword);
    if (isDebug()) console.log("@@@ 검색 키워드:", keyword, onSearch);
    navigate(`?q=${encodeURIComponent(keyword)}`, { replace: true }); //
  };

  const handleClearInput = () => {
    setKeyword("");
    navigate("/search", { replace: true });
  };

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <form onSubmit={searchByKeyword} style={{ width: "100%" }}>
        <TextField
          value={keyword}
          onChange={(e) => {
            if(onChangeText) {
              onChangeText(e.target.value)
            }
            setKeyword(e.target.value)
          }}
          fullWidth
          id="search"
          type="search"
          variant="outlined"
          placeholder={i18n.language.toLowerCase() === 'ko' ? `${t('beens.name')}${t('beens.placeholder')}` : `${t('beens.placeholder')}  ${t('beens.name')}`}
          sx={{
            minWidth: 280,
            borderRadius: 50,
            "& .MuiOutlinedInput-root": {
              borderRadius: 50,
              height: 45,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton type="submit" aria-label="search">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: keyword && (
              <InputAdornment position="end">
                <IconButton onClick={handleClearInput} aria-label="clear input">
                  <ReplayIcon sx={{ color: "#aaa" }} fontSize="large" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </form>
    </Box>
  );
};
